import PBCodes from "./PBCodes"
import { useAbac } from "react-abac"
import useFeatureFlags from "hooks/useFeatureFlags"
import { FeatureFlagEnums } from "types/featureFlags.type"
import { useEffect, useMemo } from "react"
import { Divider, Segmented } from "antd-v5"
import PBTerms from "./PBTerms"
import { PAY_BILL_TABS, PayBillOptions } from "types/payBill.types"
import { useAdminQueryParams } from "hooks"

const Index = () => {
	const { userHasPermissions } = useAbac()
	const { featureFlagEnabled } = useFeatureFlags()
	const { params, setSearchParams } = useAdminQueryParams()
	const { tab } = params
	const options: PayBillOptions[] = useMemo(() => {
		return [
			{
				label: "PB Codes",
				perform: [],
				featureName: FeatureFlagEnums.ADMIN_PAYBILL_PB_CODES,
				component: <PBCodes />,
				value: PAY_BILL_TABS.PB_CODES,
			},
			{
				label: "PB Terms",
				perform: [],
				featureName: FeatureFlagEnums.ADMIN_PAYBILL_TERMS,
				component: <PBTerms />,
				value: PAY_BILL_TABS.PB_TERMS,
			},
		]
			.map(item => ({ ...item, value: item.value }))
			.filter(item => userHasPermissions(item.perform) && featureFlagEnabled(item.featureName))
	}, [])

	const doesTabExist = useMemo(() => options.some(({ value }) => value === tab), [options, tab])

	const component = useMemo(() => {
		return options?.find(item => item.value === (doesTabExist ? tab : options[0]?.value))?.component
	}, [doesTabExist, tab])

	useEffect(() => {
		setSearchParams({ tab: tab || options[0]?.value })
	}, [options, tab])

	return (
		<div>
			<Divider style={{ margin: "8px", marginLeft: "0px", marginRight: "0px" }} />
			<div className="flex items-center justify-start">
				<Segmented
					options={options}
					value={doesTabExist ? tab : options[0]?.value}
					onChange={value => setSearchParams({ tab: value as string, selected: "" })}
				/>
			</div>
			<Divider style={{ margin: "8px", marginLeft: "0px", marginRight: "0px" }} />
			{component && <div className="px-2">{component}</div>}
			{/* <div className="px-2">
				{options?.find(({ value }) => value === (tab && doesTabExist ? tab : options[0]?.value))?.component}
			</div> */}
		</div>
	)
}

export default Index
